import {useEffect} from 'react';
import PropTypes from 'prop-types';
import {SelectOptionsController} from "./options.controller";

export const SelectOptions = (props) => {
    const {id, init, value, options, onSelect, onDestroy} = props;
    const controller = new SelectOptionsController(id, value, options, onSelect, onDestroy);

    useEffect(() => init ? controller.init() : controller.destroy());

    return '';
};

SelectOptions.propTypes = () => ({
    init: PropTypes.bool,
    value: PropTypes.string,
    options: PropTypes.array,
    onSelect: PropTypes.func,
    onDestroy: PropTypes.func,
});
